import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import Dashboard from "./Dashboard";
import OngoingOrders from "./order/OngoingOrders";
import ProfileSettings from "./admin/ProfileSettings";
import ChangePassword from "./admin/ChangePassword";
import ForgotPassword from "./admin/ForgotPassword";
import AllMerchants from "./merchants/AllMerchants";
import MerchantDetails from "./merchants/MerchantDetails";
import CreateMerchant from "./merchants/CreateMerchant";
import AllNotifications from "./merchants/AllNotifications";
import AlertProvider from "./contexts/AlertProvider";
import AuthProvider from "./contexts/AuthProvider";
import EditMerchant from "./merchants/EditMerchant";
import MerchantArchive from "./archive/MerchantArchive";
import AllEmployees from "./merchants/AllEmployees";
import EmployeesArchive from "./archive/EmployeesArchive";
import MerchantGroups from "./merchants/MerchantGroups";
import AllDelivaryCompanies from "./delivaryCompanies/AllDelivaryCommpanies";
import CreateDelivaryCompany from "./delivaryCompanies/CreateDelivaryCompany";
import EditDelivaryCompany from "./delivaryCompanies/EditDelivaryCompany";
import CompanyDetails from "./delivaryCompanies/CompanyDetails";
import DelivaryCompanyArchive from "./archive/DelivaryCompanyArchive";
import AllDrivers from "./driver/AllDrivers";
import CreateDriver from "./driver/CreateDriver";
import DriverDetails from "./driver/DriverDetails";
import EditDriver from "./driver/EditDriver";
import DriverArchive from "./archive/DriverArchive";
import AllOrders from "./order/AllOrders";
import EditOrder from "./order/EditOrder";
import OrderDetails from "./order/OrderDetails";
import PricingSheet from "./merchants/PricingSheet";
import AllTransactions from "./merchants/AllTransactions";
import DriverSharing from "./settings/DriverSharing";
import MobileMenuProvider from "./contexts/MobileMenuProvider";
import PricingModel from "./settings/PricingModel";
import ConfigureRoles from "./settings/ConfigureRoles";
import UserRole from "./settings/UserRole";
import RevenueStat from "./settings/RevenueStat";
import DriverReport from "./settings/DriverReport";
import UpdateNotifier from "./layout/UpdateNotifier";
import Ordable from "./integrations/Ordable";

const App = () => {
  return (
    <>
      <UpdateNotifier />
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <MobileMenuProvider>
          <AuthProvider>
            <AlertProvider>
              <Routes>
                <Route path="/">
                  <Route index element={<Home />} />
                  <Route path="login" element={<Login />} />
                  <Route path="dashboard/">
                    <Route index element={<Dashboard />} />
                    <Route path="ongoing-orders" element={<OngoingOrders />} />
                  </Route>
                  <Route
                    path="profile-settings"
                    element={<ProfileSettings />}
                  />
                  <Route path="change-password" element={<ChangePassword />} />
                  <Route path="forgot-password" element={<ForgotPassword />} />
                  <Route path="merchants/">
                    <Route path="all-merchants" element={<AllMerchants />} />
                    <Route
                      path="merchant-details/:id"
                      element={<MerchantDetails />}
                    />
                    <Route
                      path="create-merchant"
                      element={<CreateMerchant />}
                    />
                    <Route
                      path="edit-merchant/:id"
                      element={<EditMerchant />}
                    />
                    <Route path="all-employees" element={<AllEmployees />} />
                    <Route path="groups" element={<MerchantGroups />} />
                    <Route path="pricing-sheet" element={<PricingSheet />} />
                    <Route
                      path="all-transactions"
                      element={<AllTransactions />}
                    />
                    <Route
                      path="all-notifications"
                      element={<AllNotifications />}
                    />
                  </Route>
                  <Route path="drivers/">
                    <Route path="all-drivers" element={<AllDrivers />} />
                    <Route path="create-driver" element={<CreateDriver />} />
                    <Route
                      path="driver-details/:id"
                      element={<DriverDetails />}
                    />
                    <Route path="edit-driver/:id" element={<EditDriver />} />
                  </Route>
                  <Route path="orders/">
                    <Route path="all-orders" element={<AllOrders />} />
                    <Route path="edit-order/:id" element={<EditOrder />} />
                    <Route
                      path="order-details/:id"
                      element={<OrderDetails />}
                    />
                  </Route>
                  <Route path="delivary-companies/">
                    <Route
                      path="all-delivary-companies"
                      element={<AllDelivaryCompanies />}
                    />
                    <Route
                      path="company-details/:id"
                      element={<CompanyDetails />}
                    />
                    <Route
                      path="create-delivary-company"
                      element={<CreateDelivaryCompany />}
                    />
                    <Route
                      path="edit-delivary-company/:id"
                      element={<EditDelivaryCompany />}
                    />
                  </Route>
                  <Route path="archive/">
                    <Route path="merchants" element={<MerchantArchive />} />
                    <Route path="employees" element={<EmployeesArchive />} />
                    <Route path="drivers" element={<DriverArchive />} />
                    <Route
                      path="delivary-companies"
                      element={<DelivaryCompanyArchive />}
                    />
                  </Route>
                  <Route path="settings/">
                    <Route
                      path="configure-roles"
                      element={<ConfigureRoles />}
                    />
                    <Route path="user-role" element={<UserRole />} />
                    <Route path="driver-sharing" element={<DriverSharing />} />
                    <Route path="pricing-model" element={<PricingModel />} />
                    <Route path="revenue-stat" element={<RevenueStat />} />
                    <Route path="driver-report" element={<DriverReport />} />
                  </Route>
                  <Route path="integrations/">
                    <Route path="ordable" element={<Ordable />} />
                  </Route>
                </Route>
              </Routes>
            </AlertProvider>
          </AuthProvider>
        </MobileMenuProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
